import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddPetHistory from './AddPetHistory.js';

export default function AnimalHistory({ dialogOpen, setDialogOpen, updateID, setUpdateID }) {
  const [AnimalHistory, setAnimalHistory] = useState([]);
  const [AddHistoryDialogOpen, setAddHistoryDialogOpen] = useState(false);
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [loading, setLoading] = useState(false)

  function handleClick() {
    setAddHistoryDialogOpen(true);
  }

  useEffect(() => {

    GetAnimalDetailsById(updateID)


  }, [])


  useEffect(() => {
    GetAnimalDetailsById(updateID);
  }, [updateID]);

  useEffect(() => {
    filterHistory();
  }, [AnimalHistory, startDate, endDate]);

  const handleClose = () => {
    setDialogOpen(false);
    setAnimalHistory([]);
  };

  function GetAnimalDetailsById(a) {
    axios.get(`https://serverfourpaws.ccsoftwares.com/Pet/getPetHistory/${a}`).then((res) => {
      if (res.data.length > 0) {
        setAnimalHistory(res.data);
      }
    });
  }

  const filterHistory = () => {
    let filtered = AnimalHistory;

    if (startDate) {
      filtered = filtered.filter((item) => new Date(item.Date) >= new Date(startDate));
    }
    if (endDate) {
      filtered = filtered.filter((item) => new Date(item.Date) <= new Date(endDate));
    }

    setFilteredHistory(filtered);
  };

  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      open={dialogOpen}
      fullWidth={true}
      maxWidth="xl"
    >
      <DialogTitle sx={{ m: 0, p: 3 }} id="customized-dialog-title">
        <strong>Animal History</strong>
      </DialogTitle>
      <Button
        aria-label="add"
        variant="contained"
        size="large"
        onClick={handleClick}
        sx={{
          position: 'absolute',
          right: '4%',
          top: 8,
        }}
      >
        New
      </Button>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon sx={{ color: 'black' }} />
      </IconButton>
      <DialogContent dividers>
        <Container maxWidth={false}>
          {/* Date Range Filters */}
          <Box sx={{ mb: 2 }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={5}>
                <TextField
                  label="Start Date"
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={5}>
                <TextField
                  label="End Date"
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setStartDate('');
                    setEndDate('');
                  }}
                  fullWidth
                >
                  Clear Filters
                </Button>
              </Grid>
            </Grid>
          </Box>
          {/* Animal History List */}
          {filteredHistory.map((animal, index) => (
            <Accordion key={index} defaultExpanded={index === 0}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
              >
                <Typography sx={{ color: 'black', fontWeight: 'bold' }}>
                  {`Appointment On: ${animal.Date.split('T')[0]}`}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <strong>Doctor:</strong> {animal.Doctor}
                </Typography>
                <Typography>
                  <strong>Description:</strong> {animal.Description}
                </Typography>
                <Typography>
                  <strong>Date:</strong> {new Date(animal.Date).toLocaleDateString()}
                </Typography>
                {/* Display Download Link if FilePath Exists */}
                {animal.FilePath && (
                  <Typography>
                    <strong>Attachment:</strong>{' '}
                    <a
                      href={`https://serverfourpaws.ccsoftwares.com/${animal.FilePath}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                    >
                      View / Download File
                    </a>
                  </Typography>
                )}
              </AccordionDetails>
            </Accordion>
          ))}
        </Container>
        <AddPetHistory
          dialogOpen={AddHistoryDialogOpen}
          setDialogOpen={setAddHistoryDialogOpen}
          updateID={updateID}
          setUpdateID={setUpdateID}
        />
      </DialogContent>
    </Dialog>
  );
}
